module.exports = __webpack_public_path__ + "img/中汽联@2x.a732dc5a.png";